import * as ActionTypes from "../ActionTypes";
import * as URL from "../API_URL";
import { getRequest, postRequest, postRequest2 } from "./index";

export const login = (loginData) => {
  return postRequest(URL.LOGIN, loginData, ActionTypes.LOGIN);
};

export const signUp = (signUpData) => {
  return postRequest(URL.SIGNUP, signUpData, ActionTypes.SIGNUP);
};

export const guestLogin = (customerId) => {
  let url = URL.GUEST_LOGIN + "?customerId=" + customerId;
  return getRequest(url, ActionTypes.GUEST_LOGIN);
};

export const yearSelection = (year) => {
  return postRequest(URL.YEAR_SELECTION, year, ActionTypes.YEAR_SELECTION);
};

export const planSelectionContinue = (plan) => {
  return postRequest2(
    URL.PLAN_SELECTION_CONTINUE,
    plan,
    ActionTypes.PLAN_SELECTION_CONTINUE
  );
};

export const saveLogout = (data) => {
  return postRequest(URL.SAVE_LOGOUT, data, ActionTypes.SAVE_LOGOUT);
};

export const submitForm = (payload) => {
  return postRequest(URL.SUBMIT_FORM, payload, ActionTypes.SUBMIT_FORM);
};

export const downloadPdf = () => {
  return getRequest(URL.DOWNLOAD_PDF, ActionTypes.DOWNLOAD_PDF);
};

export const getClinicalName = (name) => {
  return getRequest(
    `${URL.GET_CLINICAL_NAME}${name}`,
    ActionTypes.GET_CLINICAL_NAME
  );
};

export const sendLink = (email) => {
  return getRequest(
    `${URL.FOR_GOT_PD}${email}`,
    ActionTypes.FOR_GOT_PD
  );
};

export const resetPassword = (data) => {
  return postRequest(URL.RE_SET_PD, data, ActionTypes.RE_SET_PD);
};


export const uploadPDF = (data) => {
  
  return postRequest(URL.PDF_UPLOAD, data, ActionTypes.PDF_UPLOAD);
};


export const removeplan = () => {
  return {
    type:ActionTypes.REMOVEPLAN,
  }
}
export const savelang=(data)=>{
  return{
    type:ActionTypes.SAVE_LANGUAGE,
    payload:data
  }
}
export const captchaValidation=(data)=>{
  return{
    type:ActionTypes.CAPTCHA,
    payload:data
  }
}